<template>
  <!--編輯-->
  <v-dialog v-model="isVisible"
            no-click-animation
            max-width="50%">
    <v-card>
      <v-card-title>銀行編輯管理</v-card-title>
      <v-card-text>
        <v-layout row wrap>
          <v-flex xs6>
            <v-autocomplete :items="getBankInfo"
                            item-text="branch"
                            item-value="key"
                            v-model="officialItem.bankId"
                            :label="`銀行`"
                            background-color='#49bcfd'
                            @change="setBankInfo"
                            outline
            ></v-autocomplete>
          </v-flex>
          <v-flex xs6>
            <v-autocomplete :items="getBankSubInfo"
                            item-text="branch"
                            item-value="code"
                            v-model="officialItem.bankSubId"
                            label="分行"
                            background-color='#49bcfd'
                            @change="setBankInfo"
                            outline
            ></v-autocomplete>
          </v-flex>
        </v-layout>
        <v-layout xs12 >
          <v-flex>
            <v-text-field
                  v-model="editedItem.name"
                  :label="`戶名`"
                  background-color='#49bcfd'
                  outline></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout xs12 >
          <v-flex>
            <v-text-field
                  v-model="editedItem.account"
                  :label="`帳戶`"
                  background-color='#49bcfd'
                  outline></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout xs12 >
          <v-flex>
            <v-checkbox
                v-model="favorite"
                label="設為常用交易帳戶"
              ></v-checkbox>
          </v-flex>
        </v-layout>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" dark text @click="closeEvent">取消</v-btn>
          <v-btn class="primary" dark text @click="confirmEvent">確定</v-btn>
        </v-card-actions>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import BankInfoModel from '../models/BankInfoModel';
import { getNow } from '@/pages/utils/tool';
const bankCodeList = require('../assets/bank_data.json');

export default {
  name: 'BankEditorDialog',
  props: {
    visible: Boolean,
    item: Object,
  },
  data() {
    return {
      loading: false,
      isVisible:false,
      favorite:false,
      officialItem:{
        bankId:'',
        bankSubId:''
      },
    };
  },
  created() {

  },
  watch:{
    visible(value){
      this.isVisible = value;
    },
    isVisible(value) {
      if(value) {
        this.favorite = !!this.item.favorite
        this.officialItem.bankId = this.item.title;
        this.officialItem.bankSubId = this.item.subTitle;
      } else {
        this.closeEvent()
      }
    }
  },
  computed:{
    ...mapGetters(['getUserInfo',]),
    isAdmin() {
      return this.getUserInfo.authority === 'admin';
    },
    editedItem() {
      const info = this.item || new BankInfoModel()
      return info
    },
    getBankInfo(){
      let bankCopyList= JSON.parse(JSON.stringify(bankCodeList));
      let list = [];
      Object.keys(bankCopyList).forEach(key=>{
        const bankInfo = bankCopyList[key];
        bankInfo.branch = `(${key})${bankInfo.branch}`
        bankInfo.key = key;
        if (bankInfo.child.length > 0){
          list.push(bankInfo);
        }
      });
      return list;
    },
    getBankSubInfo(){
      let list = [];
      let bankInfo = bankCodeList[this.officialItem.bankId];

      if (bankInfo){
        bankInfo.child.forEach(info=>{
          let copyItemInfo = {};
          Object.assign(copyItemInfo,info);
          copyItemInfo.branch = `(${info.code})${info.branch}`
          copyItemInfo.code = info.code.substring(3, info.code.length);
          list.push(copyItemInfo);
        });
      }
      return list;
    },
  },
  methods: {
    setBankInfo() {
      let bankInfoList = bankCodeList[this.officialItem.bankId];
      console.log(`bankInfoList == ${this.officialItem.bankId} ${JSON.stringify(bankInfoList)}`);
      this.editedItem.title = this.officialItem.bankId
      const array = bankInfoList.child.filter(element => element.code === `${this.officialItem.bankId}${this.officialItem.bankSubId}`)
      this.editedItem.subTitle = array.length ? this.officialItem.bankSubId : ''
    },
    confirmEvent(){
      this.editedItem.favorite = this.favorite ? 1 : 0
      this.$emit('confirmEvent', this.editedItem);
    },
    closeEvent() {
      this.$emit('closeEvent');
    }
  }
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/BankEditorDialog.vue